function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7604 8.90625V6.66667H8.90625V2.23958H6.66667V6.66667H2.23958V8.90625H6.66667V17.7604H8.90625V8.90625H17.7604ZM17.7604 0C18.3854 0 18.9062 0.225694 19.3229 0.677083C19.7743 1.09375 20 1.61458 20 2.23958V17.7604C20 18.3854 19.7743 18.9236 19.3229 19.375C18.9062 19.7917 18.3854 20 17.7604 20H2.23958C1.61458 20 1.07639 19.7917 0.625 19.375C0.208333 18.9236 0 18.3854 0 17.7604V2.23958C0 1.61458 0.208333 1.09375 0.625 0.677083C1.07639 0.225694 1.61458 0 2.23958 0H17.7604Z",
  fill: "#757D8C"
});

function SvgIconCoverageSpreadsheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "-2 -2 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgIconCoverageSpreadsheet);
export default __webpack_public_path__ + "static/media/icon-coverage-spreadsheet.b47833a4.svg";
export { ForwardRef as ReactComponent };